import { format, startOfYesterday, subMonths } from 'date-fns';

export const CHANGE_FILTER_CLASS = 'stats/reports/reservations/CHANGE_FILTER_CLASS';
export const changeFilterClass = selectedClasses => ({ type: CHANGE_FILTER_CLASS, selectedClasses });

export const CHANGE_FILTER_DATE_END = 'stats/reports/reservations/CHANGE_FILTER_DATE_END';
export const changeFilterDateEnd = endDate => ({ type: CHANGE_FILTER_DATE_END, endDate });

export const CHANGE_FILTER_DATE_START = 'stats/reports/reservations/CHANGE_FILTER_DATE_START';
export const changeFilterDateStart = startDate => ({ type: CHANGE_FILTER_DATE_START, startDate });

export const CHANGE_FILTER_VENUE = 'stats/reports/reservations/CHANGE_FILTER_VENUE';
export const changeFilterVenue = selectedVenues => ({ type: CHANGE_FILTER_VENUE, selectedVenues });

export const CHANGE_FILTER_START_TIME = 'stats/reports/reservations/CHANGE_FILTER_START_TIME';
export const changeFilterStartTime = selectedStartTimes => ({ type: CHANGE_FILTER_START_TIME, selectedStartTimes });

export const CHANGE_FILTER_STATUS = 'stats/reports/reservations/CHANGE_FILTER_STATUS';
export const changeFilterStatus = selectedStatuses => ({ type: CHANGE_FILTER_STATUS, selectedStatuses });

export const CHANGE_PAGE = 'stats/reports/reservations/CHANGE_PAGE';
export const changePage = page => ({ type: CHANGE_PAGE, page });

export const CHANGE_SORT = 'stats/reports/reservations/CHANGE_SORT';
export const changeSort = (sortDirection, sortField) => ({ type: CHANGE_SORT, sortDirection, sortField });

export const RESET_PAGE = 'stats/reports/reservations/RESET_PAGE';
export const resetPage = () => ({ type: RESET_PAGE });

export const SET_FIELDS_ENTRY = 'stats/reports/reservations/SET_FIELDS_ENTRY';
export const setFieldsEntry = venues => ({
  type: SET_FIELDS_ENTRY,
  selectedVenues: venues,
});

export const SET_FIELDS = 'stats/reports/reservations/SET_FIELDS';
export const setFields = (newClasses, newStartTimes, newStatuses) => ({
  type: SET_FIELDS,
  newClasses,
  newStartTimes,
  newStatuses,
});

export const initialState = {
  endDate: format(startOfYesterday(), 'yyyy-MM-dd'),
  startDate: format(subMonths(startOfYesterday(), 1), 'yyyy-MM-dd'),
  possibleClasses: [],
  possibleStartTimes: [],
  possibleStatuses: [],
  selectedClasses: [],
  selectedStartTimes: [],
  selectedStatuses: [],
  selectedVenues: [],
  page: 1,
  sortField: 'class_datetime',
  sortDirection: 'desc',
  hasBeenVisited: false,
};

export default (state = initialState, action) => {
  const {
    type,
    endDate,
    startDate,
    newClasses,
    newStartTimes,
    newStatuses,
    selectedClasses,
    selectedVenues,
    selectedStartTimes,
    selectedStatuses,
    page,
    sortDirection,
    sortField,
  } = action;

  switch (type) {
    case CHANGE_FILTER_CLASS:
      return { ...state, selectedClasses };
    case CHANGE_FILTER_DATE_END:
      return { ...state, endDate };
    case CHANGE_FILTER_DATE_START:
      return { ...state, startDate };
    case CHANGE_FILTER_VENUE:
      return { ...state, selectedVenues };
    case CHANGE_FILTER_START_TIME:
      return { ...state, selectedStartTimes };
    case CHANGE_FILTER_STATUS:
      return { ...state, selectedStatuses };
    case CHANGE_PAGE:
      return { ...state, page };
    case CHANGE_SORT:
      return { ...state, sortDirection, sortField };

    case RESET_PAGE:
      return { ...state, page: 1 };
    case SET_FIELDS_ENTRY:
      return { ...state, selectedVenues, hasBeenVisited: true };
    case SET_FIELDS: {
      // reconcile selected statuses/classes/start times; we want to select everything that comes back from the endpoint EXCEPT items we've already unselected
      const selectedClassesSet = new Set(state.selectedClasses);
      const selectedStartTimesSet = new Set(state.selectedStartTimes);
      const selectedStatusesSet = new Set(state.selectedStatuses);
      const unselectedClassesSet = new Set(
        state.possibleClasses.filter(possibleClass => !selectedClassesSet.has(possibleClass))
      );
      const unselectedStartTimesSet = new Set(
        state.possibleStartTimes.filter(possibleStartTime => !selectedStartTimesSet.has(possibleStartTime))
      );
      const unselectedStatusesSet = new Set(
        state.possibleStatuses.filter(possibleStatus => !selectedStatusesSet.has(possibleStatus))
      );
      return {
        ...state,
        possibleClasses: newClasses,
        possibleStartTimes: newStartTimes,
        possibleStatuses: newStatuses,
        selectedClasses: newClasses.filter(possibleClass => !unselectedClassesSet.has(possibleClass)),
        selectedStartTimes: newStartTimes.filter(possibleStartTime => !unselectedStartTimesSet.has(possibleStartTime)),
        selectedStatuses: newStatuses.filter(possibleStatus => !unselectedStatusesSet.has(possibleStatus)),
      };
    }
    default:
      return state;
  }
};
